(() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-s2t-press]').forEach((root) => {
      if (root.dataset.s2tPressReady) return;
      root.dataset.s2tPressReady = 'true';
      const print = root.querySelector('[data-s2t-press-print]');
      if (print) {
        print.hidden = false;
        print.addEventListener('click', () => window.print());
      }
      const tablist = root.querySelector('[data-s2t-press-tabs]');
      if (!tablist) return;
      const tabs = [...tablist.querySelectorAll('[data-s2t-press-tab]')];
      const panels = [...root.querySelectorAll('[data-s2t-press-panel]')];
      const select = (name, focus = false, update = false) => {
        tabs.forEach((tab) => {
          const active = tab.dataset.s2tPressTab === name;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          if (active && focus) tab.focus();
        });
        panels.forEach((panel) => { panel.hidden = panel.dataset.s2tPressPanel !== name; });
        if (update) {
          const url = new URL(window.location.href);
          url.hash = name;
          window.history.replaceState(window.history.state, '', url);
        }
      };
      tablist.setAttribute('role', 'tablist');
      tabs.forEach((tab, index) => {
        const panel = panels.find((item) => item.dataset.s2tPressPanel === tab.dataset.s2tPressTab);
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', panel.id);
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', tab.id);
        panel.tabIndex = 0;
        tab.addEventListener('click', () => select(tab.dataset.s2tPressTab, false, true));
        tab.addEventListener('keydown', (event) => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          select(tabs[next].dataset.s2tPressTab, true, true);
        });
      });
      const fromHash = () => {
        const name = window.location.hash.slice(1);
        if (tabs.some((tab) => tab.dataset.s2tPressTab === name)) select(name);
      };
      select(window.location.hash === '#autopress' ? 'autopress' : 'easypress');
      tablist.hidden = false;
      window.addEventListener('hashchange', fromHash);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
